import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';
import { ErrorBoundary, Layer } from 'bernie-view';
import { LocalizedComponentProps, LocalizedText, withLocalization } from 'bernie-l10n';

import { HotelMapModel } from 'models';

import { UitkCardLink, UitkCardMedia } from 'uitk-react-cards';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';

import { MapDialog } from 'components/infosite/property-details/property-map/map-dialog';

const LinkTracked = ClickTracker(Link);

interface WhatsAroundMapState {
  mapActive: boolean;
}

interface WhatsAroundMapProps extends LocalizedComponentProps {
  analyticsStore?: AnalyticsStore;
  routeStore?: RouteStore;
  src: string;
  rfrr: string;
  mapModel: HotelMapModel;
  ratio?: UitkFigureAspectRatioType;
}

@withLocalization
@inject('analytics', 'routeStore')
@observer
export class WhatsAroundMap extends React.Component<WhatsAroundMapProps, WhatsAroundMapState> {
  constructor(props) {
    super(props);

    this.state = {
      mapActive: false
    };

    this.onMapDialogClose = this.onMapDialogClose.bind(this);
  }

  public shouldComponentUpdate(nextState) {
    return this.state.mapActive !== nextState.mapActive;
  }

  public componentDidMount() {
    this.setState({
      mapActive: true
    });
  }

  public render() {
    const { routeStore, src, rfrr = ':WhatsAroundMap.Open', mapModel, l10n, ratio } = this.props;
    const { mapActive } = this.state;
    const mapIsDisabled = !mapActive ? 'is-disabled' : '';
    if (!(src && mapModel)) {
      return null;
    }
    const queryBase = { pwaDialog: 'map' };
    const mapOpenQuery = routeStore.mergeQueryString(routeStore.search, queryBase);
    const linkTo = {
      pathname: routeStore.pathname,
      search: mapOpenQuery
    };

    return (
      <ErrorBoundary label="hotel.information.whats-around.map">
        <QueryRoute query={queryBase}>
          <Layer id="infosite-map" onDismiss={this.onMapDialogClose}>
            <MapDialog mapModel={mapModel} onDismiss={this.onMapDialogClose} />
          </Layer>
        </QueryRoute>
        <UitkCardMedia className={`uitk-flex ${mapIsDisabled}`}>
          <UitkFigure ratio={ratio}>
            <UitkImage alt={l10n.formatText('hotels.infosite.map.a11yLabel')} src={src} />
          </UitkFigure>
          <UitkCardLink>
            <LinkTracked linkName="Launch dynamic map" rfrr={rfrr} data-stid="whats-around-map-link" to={linkTo}>
              <LocalizedText message="hotels.infosite.map.a11yLabel" />
            </LinkTracked>
          </UitkCardLink>
        </UitkCardMedia>
      </ErrorBoundary>
    );
  }

  private onMapDialogClose() {
    if (typeof this.props.routeStore.goBack === 'function') {
      this.props.routeStore.goBack();
    }
  }
}
